import { AxiosResponse, AxiosError } from 'axios'
import { GenericButtonType } from '@/types/common/button'

export type HttpResponse<T = any> = AxiosResponse<T> | AxiosError<T> | Error | undefined

export enum ApiResponseStatus {
  Success = 0,
  BusinessLogicError = 1,
  SessionTimeout = 2,
  InvalidCSRFToken = 3,
  InvalidAllPeriod = 4,
  OutOfBtcTradingTime = 5,
  SystemError = 9,
}

export enum ApiResponseMaintenanceFlag {
  NoMaintenance = 0,
  UnderMaintenance = 1,
}

export enum ApiResponseTimeoutFlag {
  NotExpired = 0,
  Expired = 1,
}

export enum ActionType {
  Close = 'CLOSE',
  CloseApp = 'CLOSE_APP'
}

export type GenericHalfSheetButton = {
  labels: { [key: string]: string }
  actionType: ActionType
  buttonType: GenericButtonType
}

export type WbffError = {
  backendResultCode: string
  titles: { [key: string]: string }
  descriptions: { [key: string]: string }
  buttonList: Array<GenericHalfSheetButton>
}

export type WbffResponse<T = any> = {
  header: {
    resultCode: 'S0000' | 'S9999'
    resultMessage: string
    isUnderMaintenance?: boolean
  }
  payload?: T
  error?: WbffError
}

export type NormalizedWbffResponse<T> = {
  isSuccess: true
  payload: T
} | {
  isSuccess: false
  error?: WbffError
}

export enum UnifiedApiStatus {
  Success = 'Success',
  BusinessLogicError = 'BusinessLogicError',
  SessionTimeout = 'SessionTimeout',
  InvalidCSRFToken = 'InvalidCSRFToken',
  InvalidAllPeriod = 'InvalidAllPeriod',
  OutOfBtcTradingTime = 'OutOfBtcTradingTime',
  SystemError = 'SystemError',
  UnderMaintenance = 'UnderMaintenance',
  ConnectionAborted = 'ConnectionAborted',
  NoticeTimeout = 'NoticeTimeout',
}
